// extracted by mini-css-extract-plugin
export default {"btnVideo":"components_btnVideo__hh+g5"};